import { generateClient } from 'aws-amplify/api';
import Vue from 'vue';
import * as qlqueries from '../graphql/queries';

const client = generateClient();
const graphqlOperation = (query, variables) => ({ query, variables });

const state = {
    name: 'AuditLogs',
    logs: {},
    loading: false,
};

const getters = {
};

const mutations = {

    setLogs: (state, payload) => {
        Vue.set(state, 'logs', payload);
    },

    setLoading: (state, payload) => {
        Vue.set(state, 'loading', payload);
    },
};

const actions = {
    async listAuditLogs({ commit }, variables = { limit: 100 }) {
        commit('setLoading', true);
        try {
            const result = await client.graphql(
                graphqlOperation(qlqueries.listAuditLogs, variables),
            );
            const { data } = result;
            commit('setLogs', data.listAuditLogs);

            commit('setLoading', false);
            return data.listAuditLogs;
        } catch (error) {
            commit('setLoading', false);
            console.error(error);
            return { error: true, message: error.errors };
        }
    },
    async filterAuditLogs({ commit }, payload) {
        commit('setLoading', true);
        try {
            const result = await client.graphql(
                graphqlOperation(qlqueries.listAuditLogs,
                    {
                        filter: payload,
                        limit: 100,
                    }),
            );
            const { data } = result;
            commit('setLogs', data.listAuditLogs);

            commit('setLoading', false);
            return data.listAuditLogs;
        } catch (error) {
            commit('setLoading', false);
            console.error(error);
            return { error: true, message: error.errors };
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
